(function(){
  const section = document.querySelector('[data-hx-faq]');
  if(!section) return;

  /* ===== Scroll reveal (once) ===== */
  const reveal = () => {
    if(section.classList.contains('is-inview')) return;
    section.classList.add('is-inview');

    const items = Array.from(section.querySelectorAll('.hx-faq-itemrev'));
    const base = 220;
    const step = 90;

    items.forEach((el, i) => {
      el.style.transitionDelay = (base + i * step) + 'ms';
    });

    const actions = section.querySelector('.hx-faq-actionsrev');
    if(actions) actions.style.transitionDelay = (base + items.length * step + 60) + 'ms';
  };

  if(!('IntersectionObserver' in window)){
    reveal();
  } else {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if(entry.isIntersecting){
          reveal();
          io.disconnect();
        }
      });
    }, { threshold: 0.18 });

    io.observe(section);
  }

  /* ===== FAQ logic ===== */
  const wrap = section.querySelector('.hx-faqm__wrap[data-faq-limit]');
  if(!wrap) return;

  const limit = parseInt(wrap.getAttribute('data-faq-limit') || '5', 10);
  const list = wrap.querySelector('.hx-faqm__list');
  const moreBtn = wrap.querySelector('[data-faq-more-btn]');
  if(!list || !moreBtn) return;

  const items = Array.from(list.querySelectorAll('.hx-faqm__item'));
  const hiddenItems = items.slice(limit);

  function setHidden(hidden){
    hiddenItems.forEach(item => item.classList.toggle('hx-faqm__hidden', hidden));
  }

  setHidden(true);
  moreBtn.textContent = 'Show more';

  items.forEach(item => {
    const btn = item.querySelector('.hx-faqm__q');
    const a = item.querySelector('.hx-faqm__a');
    if(!btn || !a) return;

    btn.addEventListener('click', () => {
      item.classList.remove('is-press');
      void item.offsetHeight;
      item.classList.add('is-press');

      const isOpen = item.classList.contains('is-open');

      items.forEach(other => {
        if(other === item) return;
        other.classList.remove('is-open');
        const ob = other.querySelector('.hx-faqm__q');
        const oa = other.querySelector('.hx-faqm__a');
        if(ob) ob.setAttribute('aria-expanded','false');
        if(oa) oa.hidden = true;
      });

      if(isOpen){
        item.classList.remove('is-open');
        btn.setAttribute('aria-expanded','false');
        a.hidden = true;
        return;
      }

      item.classList.add('is-open');
      btn.setAttribute('aria-expanded','true');
      a.hidden = false;
      void a.offsetHeight;
    });
  });

  let expanded = false;
  moreBtn.addEventListener('click', () => {
    expanded = !expanded;
    setHidden(!expanded);
    moreBtn.textContent = expanded ? 'Show less' : 'Show more';

    if(!expanded){
      hiddenItems.forEach(item => {
        item.classList.remove('is-open');
        const btn = item.querySelector('.hx-faqm__q');
        const a = item.querySelector('.hx-faqm__a');
        if(btn) btn.setAttribute('aria-expanded','false');
        if(a) a.hidden = true;
      });
    }

    if(section.classList.contains('is-inview') && expanded){
      hiddenItems.forEach((item, idx) => {
        item.style.transitionDelay = (60 + idx * 80) + 'ms';
        item.classList.add('hx-faq-itemrev');
      });
    }
  });
})();
